import EventEmitter from 'eventemitter2';

const eventEmitter = (target) => {
    const privateProp = '_maxListeners';
    if (target.prototype.verboseMemoryLeak !== undefined && target.prototype[privateProp] !== undefined) {
        console.warn('Class', target.name, 'is already decorated with EventEmitter');
        return;
    }

    Object.assign(target.prototype, EventEmitter.prototype);
};

export default eventEmitter;
